'use strict';

/**
 * Adds discount code to cart
 */
function addDiscountCode() {
    const $form = $('.discount-promo-code-form');
    const $couponError = $('.coupon-error-message');

    $.spinner().start();
    $form.removeClass('is-invalid');
    $couponError.empty();

    $.ajax({
        url: $form.attr('action'),
        type: 'GET',
        dataType: 'json',
        data: $form.serialize()
    }).done(function (data) {
        $.spinner().stop();
        $('body').trigger('promotion:success', data);  // relic of app_storefront_base. Not handled.
        if (data.error) {
            $('.discount-promo-code-form').addClass('is-invalid');
            $couponError.html(data.errorMessage);
            $('body').trigger('promotion:error', data);
            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
        } else {
            window.location.href = data.url;
        }
    });
}

window.addEventListener('load', function () {
    $('body').on('submit', '.discount-promo-code-form', function (e) {
        e.preventDefault();
        addDiscountCode();
    });
});
